import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getInspectionAuthorityList as getInspectionAuthorityListApi,
	getInspectionAuthorityListQuery as getInspectionAuthorityListQueryApi,
	getInspectionAuthority as getInspectionAuthorityApi,
	addNewInspectionAuthorityApi,
	updateInspectionAuthorityApi,
	deleteInspectionAuthorityApi,
	checkInspectionAuthorityExistsApi,
} from '../../helpers/inspection_authority/api_helper';

export const getInspectionAuthorityList = createAsyncThunk(
	'inspectionAuthority/getInspectionAuthorityList',
	async () => {
		try {
			const response = await getInspectionAuthorityListApi();
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener entidades fiscalizadoras.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getInspectionAuthorityListQuery = createAsyncThunk(
	'inspectionAuthority/getInspectionAuthorityListQuery',
	async params => {
		try {
			const response = await getInspectionAuthorityListQueryApi(params);
			return response.data || response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getInspectionAuthority = createAsyncThunk(
	'inspectionAuthority/getInspectionAuthority',
	async inspection_authority_id => {
		try {
			const response = await getInspectionAuthorityApi(inspection_authority_id);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener entidad fiscalizadora.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewInspectionAuthority = createAsyncThunk(
	'inspectionAuthority/addNewInspectionAuthority',
	async inspection_authority => {
		try {
			const response = await addNewInspectionAuthorityApi(inspection_authority);
			toast.success('Entidad Fiscalizadora agregada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar entidad fiscalizadora.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateInspectionAuthority = createAsyncThunk(
	'inspectionAuthority/updateInspectionAuthority',
	async inspection_authority => {
		try {
			const response = await updateInspectionAuthorityApi(inspection_authority);
			toast.success('Entidad Fiscalizadora actualizada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar entidad fiscalizadora.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteInspectionAuthority = createAsyncThunk(
	'inspectionAuthority/deleteInspectionAuthority',
	async inspection_authority => {
		try {
			await deleteInspectionAuthorityApi(inspection_authority._id);
			toast.success('Entidad Fiscalizadora eliminada exitosamente.', {
				autoClose: 3000,
			});
			return inspection_authority;
		} catch (error) {
			toast.error('Error al eliminar entidad fiscalizadora.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkInspectionAuthorityExists = createAsyncThunk(
	'inspectionAuthority/checkInspectionAuthorityExists',
	async name => {
		try {
			const response = await checkInspectionAuthorityExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
